/** Potter's production delivery-choice labels; keep shared checkout events. */
import CheckoutOptions from "../../../components/base/messages/CheckoutOptions.js";
import { on, emit } from "../../../core/state.js";

export function initDeliveryLoading() {
  let timer = null;
  const cancel = () => {
    if (timer === null) return;
    clearTimeout(timer);
    timer = null;
    emit("ws-chat-typing", { active: false });
  };
  on("ws-pv-checkout-method", ({ type }) => {
    if (type !== "ship" && type !== "pickup") return;
    cancel();
    emit("ws-chat-typing", { active: true, scroll: true });
    timer = setTimeout(() => {
      timer = null;
      emit("ws-chat-typing", { active: false });
      emit("ws-checkout-method", { type });
    }, 2000);
  });
  on("ws-messages-cleared", cancel);
  on("ws-toggle", ({ isOpen }) => { if (!isOpen) cancel(); });
}

export default class PottersCheckoutOptions extends CheckoutOptions {
  _selectOption(button, buttons) {
    buttons.forEach(item => {
      item.classList.toggle("is-selected", item === button);
    });
  }

  render(message) {
    const row = super.render({
      ...message,
      data: {
        ...message?.data,
        eventName: message?.data?.eventName || "ws-pv-checkout-method",
      },
    });
    row.querySelector(".ws-checkout-chips button").textContent = "Shipping";
    return row;
  }
}
